import styled from "styled-components";
import Spacer from "components/global/Spacer";
import { connect } from "react-redux";
import Button from "components/global/Button";
import Backdrop from "components/global/Backdrop";
import ModalWrapper from "./ModalWrapper";
import useSwitchWorkspace from "hooks/useSwitchWorkspace";
import { setBrandDetails } from "api";

const Wrapper = styled(Backdrop)`
  .card {
    width: 480px;
    padding: 48px;
    background-color: var(--white);
    border-radius: 16px;

    .title {
      font-size: 18px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }

    .description {
      font-size: 16px;
      font-style: normal;
      font-weight: 450;
      line-height: 24px;
    }

    .btn {
      font-size: 14px;
      font-style: normal;
      font-weight: 450;
      line-height: 18px;
    }
  }

  @media screen and (max-width: 768px) {
    .card {
      width: calc(100% - 24px);
      padding: 24px;

      .title {
        font-size: 16px;
        line-height: 20px;
      }

      .description {
        font-size: 14px;
        line-height: 20px;
      }

      .btn {
        font-size: 14px;
        font-style: normal;
        font-weight: 450;
        line-height: 18px;
      }
    }
  }
`;

const UserLockedModal = ({
  member,
  user_accounts,
  user,
  active_account,
  setBrandDetails,
}) => {
  const { saveAccountId } = useSwitchWorkspace(
    active_account,
    user_accounts,
    setBrandDetails,
    user,
  );

  const userAccount = user_accounts?.find(
    (account) => account.owner.id === user.id
  );

  const switchWorkspace = () => {
    saveAccountId(userAccount);
  };

  return (
    <Wrapper
      className={`confirmModal flexRow alignCenter justifyEnd ${
        member?.user_status_on_account !== 1 && !userAccount && "show"
      }`}
    >
      <ModalWrapper>
        <div className="card flexColumn alignCenter">
          <h5 className="colorGrey1 textCenter title">Account Error!</h5>
          <Spacer y={0.6} />
          <p className="l2 colorBodyText textCenter description">
            You have been locked out of this workspace. Please contact the
            workspace owner.
          </p>
          <Spacer y={2.4} />

          <div className="flexRow justifySpaceBetween fullWidth actionBtns">
            <Spacer x={2.4} xMobile={1.2} />
            <Button
              className="btn"
              text="Switch to my workspace"
              fullWidth
              bg="var(--secondary)"
              onClick={switchWorkspace}
            />
          </div>
        </div>
      </ModalWrapper>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    member: state.member,
    user_accounts: state.user_accounts,
    user: state.user,
    active_account: state.active_account,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setBrandDetails: (data) => dispatch(setBrandDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserLockedModal);
